import { SendLeadModalEnum } from 'src/app/_enums/send-lead-modal.enum';
import { Lead } from 'src/app/_types/lead.types';
import { GROUPE_MUTUEL_NAME } from 'src/app/constants/insurance/health.constants';

/**
 * Determines which insurer send-lead modal should be used for a given lead.
 * Returns null when no insurer modal applies.
 *
 * To support a new insurer:
 *  1. Add a value to SendLeadModalEnum
 *  2. Add an else-if branch here with the eligibility conditions
 *  3. Import the new modal component in SendLeadActionComponent and add the @if block in its template
 */
export function getSendLeadModal(lead: Lead): SendLeadModalEnum | null {
  if (!lead?.metadata || lead.proposalCount !== 0) return null;

  if (canSendLeadToGroupeMutuel(lead)) return SendLeadModalEnum.GROUPE_MUTUEL;

  // Add future insurer checks here:
  // if (...) return SendLeadModalEnum.NEW_INSURER;

  return null;
}

const canSendLeadToGroupeMutuel = (lead: Lead) => {
  const { chosenBaseOffer, chosenComplementaryOffer } = lead.metadata;
  const matchesGroupeMutuel = (
    insuranceName: string | undefined,
    thirdPartyIds: unknown[] | undefined
  ) =>
    insuranceName?.toLocaleLowerCase() ===
      GROUPE_MUTUEL_NAME.toLocaleLowerCase() && thirdPartyIds?.length > 0;

  if (
    matchesGroupeMutuel(
      chosenBaseOffer?.insuranceName,
      chosenBaseOffer?.thirdPartyIds
    ) ||
    matchesGroupeMutuel(
      chosenComplementaryOffer?.insuranceName,
      chosenComplementaryOffer?.thirdPartyIds
    )
  ) {
    return true;
  }
  return false;
};
